import React from 'react';
import styles from './logoContact.css'

const LogoContact = () =>
    (
        <div className = {styles.logo_contact}>
            <svg 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 260.74 68.69">
                <text transform="translate(66.13 58.94) scale(1.04 1)">
                    CONTACT
                </text>
                <rect x="31.24" y="31.4" width="27.5" height="27.5"/>
                <path d="M49.3,118.11A29.36,29.36,0,1,1,78.66,88.75H49.3Z" transform="translate(-19.94 -59.4)"/>
            </svg>
        </div>
    )

export default LogoContact;